var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowItWork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9981 11.5895C15.6812 11.6992 15.3237 11.9267 15.145 12.1338C14.9785 12.3207 14.7957 12.7107 14.7429 12.9909C14.7185 13.1331 14.7022 15.5542 14.7022 20.0185C14.7022 27.5172 14.69 27.0907 14.9541 27.5904C15.0435 27.7529 15.1694 27.9032 15.3319 28.0372C15.9371 28.5409 16.644 28.6384 17.2817 28.3053C17.8504 28.0088 28.5705 21.424 28.7533 21.2575C29.1189 20.9284 29.3017 20.4938 29.2976 19.9616C29.2976 19.6651 29.2813 19.6001 29.1351 19.2914C29.0295 19.0598 28.9036 18.877 28.7654 18.7389C28.607 18.5764 27.3234 17.7721 23.0419 15.1601C20.0074 13.3037 17.4483 11.7479 17.3548 11.6992C16.9161 11.4798 16.4246 11.4392 15.9981 11.5895Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWork);
export default __webpack_public_path__ + "static/media/how-it-work.643815d18837a51b8b47c101c793adad.svg";
export { ForwardRef as ReactComponent };